export default "__VITE_ASSET__c19faa98__"